import { render, staticRenderFns } from "./taskModal.vue?vue&type=template&id=1fec87ee&scoped=true&"
import script from "./taskModal.vue?vue&type=script&lang=js&"
export * from "./taskModal.vue?vue&type=script&lang=js&"
import style0 from "./taskModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./taskModal.vue?vue&type=style&index=1&id=1fec87ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fec87ee",
  null
  
)

export default component.exports